import React, { useEffect, useState } from "react";
import TrackItStatus from "./TrackItStatus";
import useFetchTransactionDetails from "../hooks/useFetchTransactionDetails";
import TransactionStatusPage from "./TransactionStatusPage";
import Modal from "react-modal";
import { useStepContext } from "@mui/material";

const TrackItComponent = ({
  customerName,
  flowLinkType,
  referenceIdentifier,
  onClose,
}) => {
  const {
    fetchTransactions,
    transactionDetails,
    transactionsLoading,
    transactionsError,
  } = useFetchTransactionDetails();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedMessageGroupId, setSelectedMessageGroupId] = useState(null);
  const [selectedDocumentIdentifier, setSelectedDocumentIdentifier] =
    useState(null);
  const [documentType, setDocumentType] = useState(null);

  // Fetch transaction details on component mount
  useEffect(() => {
    const fetchTransaction = async () => {
      setLoading(true); // Start loading
      try {
        await fetchTransactions(
          customerName,
          referenceIdentifier,
          null,
          null,
          null,
          null,
          flowLinkType
        );
      } catch (err) {
        console.error("Failed to load transaction data:", err);
      } finally {
        setLoading(false); // End loading
      }
    };

    if (customerName && referenceIdentifier && flowLinkType) {
      fetchTransaction(); // Only fetch when all parameters are available
    } else {
      console.warn("Missing required parameters for fetching transactions");
      setLoading(false);
    }
  }, [fetchTransactions, customerName, referenceIdentifier, flowLinkType]);

  // Update modal state based on transactionDetails and loading
  useEffect(() => {
    if (!loading && transactionDetails?.transactionList?.transaction) {
      const transaction = Array.isArray(
        transactionDetails.transactionList.transaction
      )
        ? transactionDetails.transactionList.transaction[0]
        : transactionDetails.transactionList.transaction;

      setSelectedMessageGroupId(transaction?.messageGroupId || null);
      setDocumentType(transaction?.documentType || null);
      setSelectedDocumentIdentifier(referenceIdentifier);
      setIsModalOpen(true); // Open the modal if transaction details exist
    } else {
      setIsModalOpen(false); // Close the modal if no data or still loading
    }
  }, [transactionDetails, loading, referenceIdentifier]);

  const closeModal = () => {
    setIsModalOpen(false); // Explicitly close the modal
    if (onClose) {
      onClose(); // Call parent's onClose handler
    }
  };

  if (transactionsLoading || loading) {
    return <div>Loading...</div>;
  }

  if (transactionsError) {
    return <div>Error: {transactionsError}</div>;
  }

  if (!transactionDetails || !transactionDetails.transactionList) {
    return <div>No transaction found</div>;
  }

  return (
    <div className="transaction-group-container">
      {/* Render the modal directly, control visibility through isOpen */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal} // Handle outside click or esc to close modal
        contentLabel="TrackItStatus Modal"
        ariaHideApp={false}
        style={{
          content: {
            width: "90%",
            maxWidth: "1000px",
            maxHeight: "550px",
            margin: "auto",
            overflowY: "auto",
            padding: "20px",
            borderRadius: "8px",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
          },
        }}
      >
        {/* Ensure TrackItStatus renders correctly */}
        {isModalOpen && (
          <TransactionStatusPage
            messageGroupId={selectedMessageGroupId}
            documentType={documentType}
            referenceIdentifier={selectedDocumentIdentifier}
          />
        )}
        <button onClick={closeModal} className="modal-close-button">
          Close
        </button>
      </Modal>

      {/* Display content when no transactions */}
      {!isModalOpen && <div>No transactions to display</div>}
    </div>
  );
};

export default TrackItComponent;

